import { render } from "./UserProduct.vue?vue&type=template&id=81b35e82&scoped=true"
import script from "./UserProduct.vue?vue&type=script&lang=js"
export * from "./UserProduct.vue?vue&type=script&lang=js"

import "./UserProduct.vue?vue&type=style&index=0&id=81b35e82&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b35e82"]])

export default __exports__